/* eslint-disable no-unused-vars */
/* eslint-disable no-debugger */

import store from '../store'
import axios from "axios"
//console.log('security has logged')

checkCookie()
// verify token is saved in cookie 
function checkCookie() {
    //document.cookie = 'token=;expires=;path=/';
    if (window.location.href.indexOf("resetPassword") > -1) {
        return;
    }

    var token = document.cookie.split('=')[1];
    if (!token) {
        // no token present
        var now = new Date();
        var time = now.getTime();
        var expireTime = time + 1000 * 36000;
        now.setTime(expireTime);
        store.commit("setToken", "");
        document.cookie = 'token=;expires=' + now.toGMTString() + ';path=/';
        window.location.href = "/#/login"

    } else {
        //there is token available 
        axios.defaults.headers.common = { authorization: "bearer " + token };
        axios
            .get(store.state.baseUrl + "parseToken")
            .then(response => {
                // debugger
                store.commit("setLoggedUser", response.data);
                store.commit('setToken', token);
                store.commit("setViewedVideo", response.data.viewedVideo);
                store.commit("setNeedToChangePassword", response.data.cp);
            })
            .catch(function (error) {
                console.log(error)
                document.cookie = 'token=;';
                window.location.href = "/#/login"
            })
    }


}